/**
 * @generated SignedSource<<c7d7d0938d68e75c9eb8bfe14edd2769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GameListUserProfileIndexQuery$variables = {
  userId: string;
};
export type GameListUserProfileIndexQuery$data = {
  readonly user: {
    readonly isViewer: boolean;
    readonly followerPrivacy: boolean | null;
    readonly pastGames: {
      readonly pageInfo: {
        readonly hasNextPage: boolean;
        readonly total: number;
      };
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"GameFeed_games">;
        };
      }>;
    };
    readonly upcomingGames: {
      readonly pageInfo: {
        readonly total: number;
      };
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"GameListItemCompact_game">;
        };
      }>;
    };
  } | null;
};
export type GameListUserProfileIndexQuery = {
  variables: GameListUserProfileIndexQuery$variables;
  response: GameListUserProfileIndexQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewer",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "followerPrivacy",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v5 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "START_TIME"
  }
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "times",
    "value": [
      "PAST"
    ]
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "times",
    "value": [
      "UPCOMING"
    ]
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameIsFull",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimumPlayers",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfTeams",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v18 = [
  (v10/*: any*/)
],
v19 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "players",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": "players(first:1)"
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "GameTemplate",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": (v17/*: any*/),
      "concreteType": "GameTemplatePositionConnection",
      "kind": "LinkedField",
      "name": "positions",
      "plural": false,
      "selections": (v18/*: any*/),
      "storageKey": "positions(first:1)"
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gameCost",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "GameWiewerTeam",
  "kind": "LinkedField",
  "name": "viewerTeam",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsAGoaliePlayer",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAge",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAge",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Sport",
  "kind": "LinkedField",
  "name": "sport",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsAPlayer",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Location",
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOutdoor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        (v27/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GameListUserProfileIndexQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": "pastGames",
            "args": (v6/*: any*/),
            "concreteType": "GameConnection",
            "kind": "LinkedField",
            "name": "games",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GameEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Game",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GameFeed_games"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "games(first:15,orderBy:{\"direction\":\"DESC\",\"field\":\"START_TIME\"},times:[\"PAST\"])"
          },
          {
            "alias": "upcomingGames",
            "args": (v9/*: any*/),
            "concreteType": "GameConnection",
            "kind": "LinkedField",
            "name": "games",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GameEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Game",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GameListItemCompact_game"
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "games(first:15,orderBy:{\"direction\":\"DESC\",\"field\":\"START_TIME\"},times:[\"UPCOMING\"])"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GameListUserProfileIndexQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": "pastGames",
            "args": (v6/*: any*/),
            "concreteType": "GameConnection",
            "kind": "LinkedField",
            "name": "games",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GameEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Game",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v11/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "goaliesCount",
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "viewerIsOnWaitingList",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "viewerIsOnRemindMeList",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unlockTimeTz",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "games(first:15,orderBy:{\"direction\":\"DESC\",\"field\":\"START_TIME\"},times:[\"PAST\"])"
          },
          {
            "alias": "upcomingGames",
            "args": (v9/*: any*/),
            "concreteType": "GameConnection",
            "kind": "LinkedField",
            "name": "games",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GameEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Game",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v11/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "games(first:15,orderBy:{\"direction\":\"DESC\",\"field\":\"START_TIME\"},times:[\"UPCOMING\"])"
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6cd47eb50d5941eb66dc2f835c5c8460",
    "id": null,
    "metadata": {},
    "name": "GameListUserProfileIndexQuery",
    "operationKind": "query",
    "text": "query GameListUserProfileIndexQuery(\n  $userId: ID!\n) {\n  user(id: $userId) {\n    isViewer\n    followerPrivacy\n    pastGames: games(first: 15, orderBy: {direction: DESC, field: START_TIME}, times: [PAST]) {\n      pageInfo {\n        hasNextPage\n        total\n      }\n      edges {\n        node {\n          ...GameFeed_games\n          id\n        }\n      }\n    }\n    upcomingGames: games(first: 15, orderBy: {direction: DESC, field: START_TIME}, times: [UPCOMING]) {\n      pageInfo {\n        total\n      }\n      edges {\n        node {\n          ...GameListItemCompact_game\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment CalendarIcon_game on Game {\n  startTime\n}\n\nfragment Cost_template on GameTemplate {\n  gameCost\n}\n\nfragment DateTimeTextWaitlist_game on Game {\n  endTime\n  startTime\n}\n\nfragment DateTimeText_game on Game {\n  endTime\n  startTime\n}\n\nfragment GameFeedItem_games_11YXGx on Game {\n  ...GameListItem_game_11YXGx\n  ...GameListItemCompact_game_11YXGx\n  ...GameListItemWaitlist_game\n  ...GameListItemLocked_game\n  id\n  unlockTimeTz\n  gameIsFull\n  startTime\n}\n\nfragment GameFeed_games on Game {\n  ...GameFeedItem_games_11YXGx\n  id\n  startTime\n}\n\nfragment GameListItemCompact_game on Game {\n  ...CalendarIcon_game\n  ...DateTimeText_game\n  ...ProgressBar_game\n  ...ShirtIcon_game\n  ...SportAndAgesText_game\n  ...Title_game\n  url\n  viewerIsAPlayer\n  location {\n    ...LocationText_location\n    id\n  }\n  sport {\n    ...SportIcon_sport\n    slug\n    id\n  }\n  template {\n    ...Cost_template\n    id\n  }\n  isCancelled\n}\n\nfragment GameListItemCompact_game_11YXGx on Game {\n  ...CalendarIcon_game\n  ...DateTimeText_game\n  ...ProgressBar_game\n  ...ShirtIcon_game\n  ...SportAndAgesText_game\n  ...Title_game\n  url\n  viewerIsAPlayer\n  location {\n    ...LocationText_location\n    id\n  }\n  sport {\n    ...SportIcon_sport\n    slug\n    id\n  }\n  template {\n    ...Cost_template\n    id\n  }\n  isCancelled\n}\n\nfragment GameListItemLocked_game on Game {\n  ...DateTimeTextWaitlist_game\n  ...TitleWaitlist_game\n  ...RemindButton_game\n  ...UpcomingCountdown_game\n  id\n  url\n  location {\n    ...LocationTextWaitlist_location\n    id\n  }\n  sport {\n    slug\n    ...SportIcon_sport\n    id\n  }\n}\n\nfragment GameListItemWaitlist_game on Game {\n  ...DateTimeTextWaitlist_game\n  ...TitleWaitlist_game\n  ...WaitlistButton_game\n  ...ShirtIcon_game\n  viewerIsAPlayer\n  gameIsFull\n  id\n  url\n  location {\n    ...LocationTextWaitlist_location\n    id\n  }\n  numberOfTeams\n  players(first: 1) {\n    pageInfo {\n      total\n    }\n  }\n  sport {\n    slug\n    ...SportIcon_sport\n    id\n  }\n  template {\n    ...Cost_template\n    positions(first: 1) {\n      pageInfo {\n        total\n      }\n    }\n    id\n  }\n}\n\nfragment GameListItem_game_11YXGx on Game {\n  ...CalendarIcon_game\n  ...DateTimeText_game\n  ...ProgressBar_game\n  ...ShirtIcon_game\n  ...SportAndAgesText_game\n  ...Title_game\n  ...GoalieIcon_game\n  url\n  viewerIsAPlayer\n  location {\n    ...LocationText_location\n    id\n  }\n  sport {\n    ...SportIcon_sport\n    slug\n    id\n  }\n  template {\n    ...Cost_template\n    id\n  }\n}\n\nfragment GoalieIcon_game on Game {\n  goaliesCount\n}\n\nfragment LocationTextWaitlist_location on Location {\n  name\n  facility {\n    name\n    id\n  }\n}\n\nfragment LocationText_location on Location {\n  name\n  isOutdoor\n  facility {\n    name\n    id\n  }\n}\n\nfragment ProgressBar_game on Game {\n  gameIsFull\n  id\n  minimumPlayers\n  numberOfTeams\n  players(first: 1) {\n    pageInfo {\n      total\n    }\n  }\n  template {\n    positions(first: 1) {\n      pageInfo {\n        total\n      }\n    }\n    id\n  }\n}\n\nfragment RemindButton_game on Game {\n  id\n  viewerIsOnRemindMeList\n}\n\nfragment ShirtIcon_game on Game {\n  viewerTeam {\n    color\n  }\n  viewerIsAGoaliePlayer\n}\n\nfragment SportAndAgesText_game on Game {\n  endAge\n  startAge\n  title\n  sport {\n    name\n    id\n  }\n}\n\nfragment SportIcon_sport on Sport {\n  slug\n}\n\nfragment TitleWaitlist_game on Game {\n  title\n  sport {\n    name\n    id\n  }\n}\n\nfragment Title_game on Game {\n  title\n  sport {\n    name\n    id\n  }\n}\n\nfragment UpcomingCountdown_game on Game {\n  unlockTimeTz\n}\n\nfragment WaitlistButton_game on Game {\n  id\n  viewerIsOnWaitingList\n}\n"
  }
};
})();

(node as any).hash = "9363f42c8c339f9c882b08fcd4ecd083";

export default node;
